export default __webpack_public_path__ + "static/media/Step-01.56edb973.jpg";